const apiBaseURL = process.env.REACT_APP_BASE_API_URL || '';
const mainAppURL = process.env.REACT_APP_MAIN_APP_URL || '';

const hwrApiURL = '/api/HWRs';
const forecastApiURL = '/api/ForecastQuotes';
const cadenceApiURL = '/api/Cadences';
const renewalsApiURL = '/api/RenewalsQuotes';
const entitlementsApiURL = '/api/Entitlements';
const cognosImportLogs = '/api/CognosImportLogs';
const odsImportLogs = '/api/odsImportLogs';
const competitiveTakeoutApiURL = '/api/CompetitiveTakeouts';
const forecastSubscriptionsApiURL = '/api/EmailSubscriptions';
const forecastFLMMapApiURL = '/api/ForecastOpportunityOwnerFLMMaps';
const forecastFLMApiURL = '/api/ForecastFLMs';
const qRadarPartDetailsApiURL = '/api/EntitlementPartDetails';
const countriesApiURL = '/api/countries';
const usersApiURL = '/api/users';
const customApiURL = '/api/customs';
const configurationsApiURL = '/api/configurations';
const tasksApiURL = '/api/tasks';
const requestSupportApiURL = '/api/RequestSupportLogs';
const angularAppPrefix = '/v1';

module.exports = {
  auth: {
    self: '/api/users/me',
  },
  api: {
    tasks: `${usersApiURL}/tasks`,
    copyConfiguration: `${configurationsApiURL}/copy-configuration`,
    archiveTasks: `${tasksApiURL}/archive-tasks`,
    exportToExcelTasks: `${configurationsApiURL}/export-to-excel-tasks`,
    addQuote: `${forecastApiURL}/add-quote`,
    findQuotes: `${forecastApiURL}/find-quotes`,
    getTotalAppliances: `${forecastApiURL}/get-total-appliances`,
    transferTotalsData: `${forecastApiURL}/transfer-totals-data`,
    copyInventoryData: `${forecastApiURL}/copy-inventory-data`,
    updateQuote: `${forecastApiURL}/update-quote`,
    updateQuoteMultiFields: `${forecastApiURL}/update-quote-multi-fields`,
    findValues: `${forecastApiURL}/find-values`,
    findMTMTotals: `${forecastApiURL}/find-mtm-totals`,
    updateMTM: `${forecastApiURL}/update-mtm`,
    updateMTMFromInventoryModal: `${forecastApiURL}/update-mtm-from-inventory-modal`,
    getMTMList: `${forecastApiURL}/get-mtm-list`,
    exportToExcel: `${forecastApiURL}/export-to-excel`,
    exportTotalsToExcel: `${forecastApiURL}/export-totals-to-excel`,
    findOpportunityOwnersWithNoFLM: `${forecastApiURL}/find-opportunity-owners-with-no-flm`,
    findSubscriptions: `${forecastSubscriptionsApiURL}/find-subscriptions`,
    updateSubscriptions: `${forecastSubscriptionsApiURL}/update-subscriptions`,
    getMapping: `${forecastFLMMapApiURL}/get-mapping`,
    updateMapping: `${forecastFLMMapApiURL}/update-mapping`,
    getFLMs: `${forecastFLMApiURL}/get-flms`,
    updateFLMs: `${forecastFLMApiURL}/update-flms`,
    findQRadarPartDetails: `${qRadarPartDetailsApiURL}/find-part-details`,
    findNewQRadarPartDetails: `${qRadarPartDetailsApiURL}/find-new-part-details`,
    updateQRadarPartDetail: `${qRadarPartDetailsApiURL}/update-part-detail`,
    createQRadarPartDetail: `${qRadarPartDetailsApiURL}/create-part-detail`,
    exportQRadarPartDetailsToExcel: `${qRadarPartDetailsApiURL}/export-to-excel`,
    getCountQRadarPartDetails: `${qRadarPartDetailsApiURL}/get-count`,
    getQRadarDetailsSyncStatus: `${qRadarPartDetailsApiURL}/get-sync-status`,
    syncQRadarDetails: `${qRadarPartDetailsApiURL}/sync`,
    getCountries: `${countriesApiURL}/get-countries-list?includeAllInfo=true`,
    forecastFindOpportunities: `${customApiURL}/forecast-find-opportunities`,
    getLatestOpportunities: `${usersApiURL}/get-latest-opportunities`,
    findOpportunities: `${customApiURL}/find-opportunities?resultsLimit=15`,
    saveLatestOpportunity: `${usersApiURL}/save-latest-opportunity`,
    createConfiguration: `${configurationsApiURL}/add-configuration`,
    sendRequestSupport: (tool, message) =>
      `${requestSupportApiURL}/send-request-support?tool=${tool}&message=${message}`,
    reports: `${customApiURL}/report`,
    renewalsReport: `${renewalsApiURL}/generate-renewals-reports`,
    competitiveTakeoutReport: `${competitiveTakeoutApiURL}/generate_competitive_takeout_report`,
    hwrManagerReport: `${hwrApiURL}/create-manager-report`,
    createFlmReport: `${hwrApiURL}/create-flm-report`,
    zeroCriteriaReport: `${entitlementsApiURL}/zero-criteria-report`,
    entitlementsTopCustomerReport: `${entitlementsApiURL}/top-customers-report`,
    dataLoadReport: `${cognosImportLogs}/cognos-import-log-report`,
    odsReport: `${odsImportLogs}/get-ods-logs-report`,
    requestSupportReport: `${requestSupportApiURL}/generate-request-support-reports`,
    findCadenceRecords: `${cadenceApiURL}/find-cadence-records`,
    updateCadenceRecord: `${cadenceApiURL}/update-cadence-record`,
    exportCadenceToExcel: `${cadenceApiURL}/export-to-excel`,
    uploadCadenceData: `${cadenceApiURL}/upload-data`,
    getLastImportDate: `${cadenceApiURL}/last-import-date`,
    addCadenceRecord: `${cadenceApiURL}/add-cadence-record`,
    getCadenceCountries: `${cadenceApiURL}/get-countries-list`,
    findCadenceValues: `${cadenceApiURL}/find-values`,
  },
  admin: {
    teams: `/api/teams`,
    getUsersWithRoles: `${customApiURL}/get-users-roles`,
    saveUsersRoles: `${customApiURL}/set-users-roles`,
    updateUsersAccesses: `${customApiURL}/update-users-accesses`,
    hwrUsers: `/api/hwrUsers?order=name+ASC`,
    hwrUser: userId => `/api/hwrUsers/${userId}`,
    updateHwrUser: 'api/hwrUsers/upsertWithWhere',
    updateFlm: '/api/HWRs/updateFLM',
  },
  applianceSN: {
    appliancesSN: '/api/applianceSerialNumbers/find-appliance-serial-number',
    applianceSN: applianceId => `/api/applianceSerialNumbers/${applianceId}`,
    addApplianceSN: '/api/applianceSerialNumbers/add-appliance-serial-number',
    updateApplianceSN: '/api/applianceSerialNumbers/update-appliance-serial-number',
  },
  public_urls: {
    home: '/',
    forecastQuoteAndDealList: '/forecast-quotes',
    forecastTotals: '/forecast-totals',
    forecastSubscriptions: '/email-subscriptions',
    forecastFLMMap: '/forecast-flm-map',
    qRadarPartDetails: '/qradar-part-details',
    applianceSN: '/appliance-serial-number',
    cadence: '/cadence',
    reports: {
      base: '/reports',
      toolsReports: '/reports/tools-reports',
      hwrMonthlyReports: '/reports/hwr-monthly-reports',
      metricsReport: '/reports/metrics-report',
      usersReport: '/reports/users-report',
      requestSupportReport: '/reports/request-support',
      entitlements: '/reports/entitlements',
      dataLoadLogs: '/reports/data-load-logs',
    },
    adminPage: '/admin',
    configurationTool: '/tasks',
    newConfiguration: '/new-config',
    createConfigurationError: '/create-configuration-error',
    w3idLogin: `${mainAppURL}/auth/w3id/auth`,
    login: `${mainAppURL}/login/`,
    logout: `${mainAppURL}/auth/logout/`,
    otherTools: {
      home: `${mainAppURL}/`,
      configurationTool: `${mainAppURL}/#/tasks`,
      hwr: `${mainAppURL}${angularAppPrefix}/#/hardware-refresh-admin`,
      salesplay: `${mainAppURL}${angularAppPrefix}/#/salesplay`,
      entitlement: `${mainAppURL}${angularAppPrefix}/#/entitlement`,
      renewals: `${mainAppURL}${angularAppPrefix}/#/renewals`,
      competitiveTakeout: `${mainAppURL}${angularAppPrefix}/#/competitive-takeout`,
    },
    userLinks: {
      outOfOffice: `${mainAppURL}${angularAppPrefix}/#/out-of-office`,
      appliance: `${mainAppURL}${angularAppPrefix}/#/appliance-serial-number`,
    },
    termsOfUse: '/terms-of-use',
  },
  externalLinks: {
    IBMSalesCloud: 'https://ibmsc.lightning.force.com/',
    IBMSalesCloudOpportunity: opportunityNumber =>
      `https://ibmsc.lightning.force.com/lightning/r/Opportunity/${opportunityNumber}/view`,
    engageSupport: 'https://engage-support.ibm.com/?customerName=test&country=US#serviceRequest/create',
    fastPass: 'https://fastpass.w3cloud.ibm.com/sales/fastpass/',
    privacyIBM: 'https://w3.ibm.com/w3publisher/w3-privacy-notice',
    privacyBP: 'https://www.ibm.com/privacy/portal/contact/us-en',
  },
  learningResourcesLinks: {
    presentations: 'https://ibm.box.com/s/btqdnhhrox43b3da2ta94zchhjf21ck2',
    presentationsForecast: 'https://ibm.box.com/s/ugvbdzniv9hj4jr4us7nmrt6iafyf6yx',
    presentationsBP: 'https://drive.google.com/drive/folders/1Pk4xo3tonyDbMZrziQOEbFHJCNrnQoHs',
    m5AppliancesOverviewBP:
      'https://www.ibm.com/support/knowledgecenter/SS42VS_7.4.0/com.ibm.qradar.doc/c_hwg_app_overview_m5.html',
    m6AppliancesOverviewBP:
      'https://www.ibm.com/support/knowledgecenter/SS42VS_7.4.0/com.ibm.qradar.doc/c_hwg_app_overview_m6.html',
  },
  requestAccess: 'mailto:MMASSEY@ie.ibm.com?subject=Request Access for SASC Tool',
  slackLink: 'https://ibm-security.slack.com/archives/C01FD1C29T9',
  apiBaseURL,
  mainAppURL,
  w3People: (query, resultsLimit) =>
    `https://w3-unifiedprofile-search.dal1a.cirrus.ibm.com/search?searchConfig=typeahead_search&start=0&rows=${resultsLimit}&query=${query}`,
  w3PeopleAvatar: userId => `https://w3-unifiedprofile-api.dal1a.cirrus.ibm.com/v3/image/${userId}?def=avatar`,
};
